import { runDemo } from "../shared/demoRunner";
import { createBonesScene } from "./scene";

runDemo({ createScene: createBonesScene });
